import { Injectable } from '@angular/core'
import { RolePermission } from './role-permission'

@Injectable()
export class RolePermissionSerializer {
  fromJson(json: any): RolePermission {
    const rolePermission = {
      ...json
    }

    return rolePermission
  }

  toJson(rolePermission: RolePermission): any {
    return {
      ...RolePermission
    }
  }
}
